// `?raw` keeps FilePond CSS out of PostCSS/Tailwind and avoids Vite emitting preloaded `_nuxt/*.css` chunks that did not match later <link> loads (credentials / unused preload warnings).
import filepondCss from 'filepond/dist/filepond.min.css?raw';
import filepondImagePreviewCss from 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css?raw';

import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import VueFilePond from "vue-filepond";

const FilePond = VueFilePond(
    FilePondPluginFileValidateType,
    FilePondPluginImagePreview
);

function injectStyle(cssText, dataAttr) {
    if (document.querySelector(`style[data-filepond="${dataAttr}"]`)) {
        return;
    }
    const style = document.createElement('style');
    style.dataset.filepond = dataAttr;
    style.textContent = cssText;
    document.head.appendChild(style);
}

export default defineNuxtPlugin(nuxtApp => {
    if (true) {
        injectStyle(filepondCss, 'core');
        injectStyle(filepondImagePreviewCss, 'image-preview');
    }
    nuxtApp.vueApp.component('FilePond', FilePond);
});
